<template>
  <div id="app" class="layout layout-nav-side">
    <div class="vld-parent">
      <Loading :active.sync="isLoading"
      :is-full-page="fullPage"></loading>
    </div>
    <Nav :gmail="gmail" />
    <div id="content" class="main-container">
      <Breadcrumb />
      <div class="container">
        <router-view/>
      </div>
    </div>
    <NewProject/>
    <NewFolder/>
  </div>
</template>

<script>
import api from "api";
import Nav from "components/Nav";
import Breadcrumb from "components/Breadcrumb";
import NewProject from "components/NewProject"
import NewFolder from "components/NewFolder"
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  props: ['gmail'],
  data() {
    return {
      isLoading: false,
      fullPage: true
    }
  },
  components: {
    Nav,
    Breadcrumb,
    NewProject,
    NewFolder,
    Loading
  },
  created() {
    this.isLoading = this.showLoadingSpinner();
    api.getProjectAreas().then(response => {
      this.project_areas = response.data;

      api.getTasks().then(response => {
        this.tasks = response.data;
        this.isLoading = false

        api.getSortedGroups().then(response => {
          this.sorted_groups = response.data.sorted_groups;
        }) 

        api.getActiveTags().then(response => {
          this.active_tags = response.data;
        });

        api.getTags().then(response => {
          this.user_tags = response.data;

          api.getContacts().then(response => {
            this.user_contacts = response.data;
          });

          api.getActiveContacts().then(response => {
            this.active_contacts = response.data;

            api.getEvents().then(response => {
              this.events = response.data;

              api.getArchivedTags().then(response => {
                this.archived_tags = response.data;

                api.getArchivedContacts().then(response => {
                  this.archived_contacts = response.data

                  api.getArchive().then(response => {
                    // add data from archived tasks to global tasks array
                    this.tasks.push(...response.data)

                    api.getArchivedProjects().then(response => {
                      this.archived_projects = response.data;
                    });
                  });                  
                })                
              });
            });
          });
        });
      });
    });
  },
  computed: {
    project_areas: {
      get() {
        return this.$store.state.project_areas
      },
      set(value){
        this.$store.state.project_areas = value
      }
    },
    tasks: {
      get() {
        return this.$store.state.tasks
      },
      set(value) {
        this.$store.state.tasks = value
      }
    },
    user_tags: {
      get() {
        return this.$store.state.user_tags
      },
      set(value) {
        this.$store.state.user_tags = value
      }
    },
    active_tags: {
      get() {
        return this.$store.state.active_tags
      },
      set(value) {
        this.$store.state.active_tags = value
      }
    },
    archived_tags: {
      get() {
        return this.$store.state.archived_tags
      },
      set(value) {
        this.$store.state.archived_tags = value
      }
    },
    user_contacts: {
      get() {
        return this.$store.state.user_contacts
      },
      set(value) {
        this.$store.state.user_contacts = value
      }
    },
    events: {
      get() {
        return this.$store.state.events
      },
      set(value) {
        this.$store.state.events = value
      }
    },
    archived_projects: {
      get() {
        return this.$store.state.archived_projects
      },
      set(value) {
        this.$store.state.archived_projects = value
      }
    },
    active_contacts: {
      get() {
        return this.$store.state.active_contacts
      },
      set(value) {
        this.$store.state.active_contacts = value
      }
    },
    archived_contacts: {
      get() {
        return this.$store.state.archived_contacts
      },
      set(value) {
        this.$store.state.archived_contacts = value
      }
    },
    sorted_groups: {
      get() {
        return this.$store.state.sorted_groups
      },
      set(value) {
        this.$store.state.sorted_groups = value
      }
    },
  },
  methods: {
    showLoadingSpinner(){
      return this.$route.name !== 'default'
    }
  }
};
</script>
